import styled from "styled-components";

export const TabelaSafra = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;